export const METRIC_LABEL_COLOR = '#475569'
export const METRIC_VALUE_COLOR = '#334155'
export const METRIC_MUTED_COLOR = '#64748b'
